import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Tag, Input, Modal, Form, Button, Select } from "antd";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useDebounce } from "../../../core/hooks/useDebounce";
import { addDevice, deleteDevice, fetchDevices, updateDevice } from "../../../core/data/redux/slices/AllDeviceSlice";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const Devices = () => {
    const dispatch = useDispatch();
    const { devices, loading } = useSelector((state) => state.devices);
    const { confirm } = Modal;
    const [localSearch, setLocalSearch] = useState("");
    const debouncedSearch = useDebounce(localSearch, 500);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingDevice, setEditingDevice] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();
  const route = all_routes;
    const openAddModal = () => {
        setEditingDevice(null);
        form.resetFields();
        setIsModalOpen(true);
    };
console.log(devices,"devicesdevices");

    const handleDeleteDevice = (deviceId) => {
        confirm({
            title: "Are you sure you want to delete this device?",
            icon: <ExclamationCircleOutlined />,
            content: "This action cannot be undone.",
            okText: "Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    console.log(deviceId, "kjhgfchvjb");

                    await dispatch(deleteDevice(deviceId)).unwrap();
                } catch (error) {
                    dispatch(
                        showToast({
                            heading: "Error",
                            message: error || "Failed to delete device",
                            variant: "danger",
                        })
                    );
                }
            },
            onCancel() {
                // Optional: do something on cancel
            },
        });
    };
    const openEditModal = (device) => {
        setEditingDevice(device);
        form.setFieldsValue({
            PBX_BASE_URL: device.PBX_BASE_URL,
            PBX_USERNAME: device.PBX_USERNAME,
            PBX_PASSWORD: device.PBX_PASSWORD,
            PBX_SDK_ACCESS_ID: device.PBX_SDK_ACCESS_ID,
            PBX_SDK_ACCESS_KEY: device.PBX_SDK_ACCESS_KEY,
            deviceName: device.deviceName,
            PBX_USER_AGENT: device.PBX_USER_AGENT || "",
            pbxType: device.pbxType || "cloud",
            isActive: device.isActive,
            deviceId: device.deviceId || ""
        });
        setIsModalOpen(true);
    };
    const handleSubmit = async (values) => {
        setSubmitting(true);
        try {
            const payload = {
                ...values,
                deviceId: editingDevice ? editingDevice.deviceId : "",
            };

            if (editingDevice) {
                await dispatch(updateDevice(payload)).unwrap();
            } else {
                await dispatch(addDevice(payload)).unwrap();
            }

            // Only close the modal on success
            setIsModalOpen(false);
        } catch (error) {
            dispatch(
                showToast({
                    heading: "Error",
                    message: typeof error === "string" ? error : "Something went wrong. Please try again.",
                    variant: "danger",
                })
            );
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        dispatch(fetchDevices());
    }, [dispatch]);

    const filteredDevices = devices?.filter((d) =>
        d.deviceName?.toLowerCase().includes(debouncedSearch.toLowerCase())
    );

    const columns = [
        {
            title: "Device Name",
            dataIndex: "deviceName",
            key: "deviceName",




  render: (text, record, index) => {

        return(
        <div className="cell-content justify-content-between">
          
 <Link
            className="customer-name"
            to={
             
                 route.deviceDetails
               
            }
            // onClick={() => dispatch(setSelectedContact(record))}
            state={{ record }}
            style={{ color: "#2c5cc5", fontWeight: 700 }}
          >
            {text}
          </Link>

        </div>
        )
      },



        },
        {
            title: "Base URL",
            dataIndex: "PBX_BASE_URL",
            key: "PBX_BASE_URL",
        },
        {
            title: "Number of Users",
            dataIndex: "assignedUsersCount",
            key: "assignedUsersCount",
        },
        {
            title: "Status",
            dataIndex: "isActive",
            key: "isActive",
            render: (status) => (
                <Tag color={status ? "green" : "red"}>
                    {status ? "Active" : "Inactive"}
                </Tag>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => {

                return (<><Button
                    type="link"
                    icon={<EditOutlined />}
                    onClick={() => openEditModal(record)}
                >
                    Edit
                </Button>
                    <Button
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteDevice(record.deviceId)}
                    >
                        Delete
                    </Button>
                </>
                )
            },
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="card">
                    <div className="card-body table-responsive custom-table">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-semibold mb-2 mt-2">All Devices</h5>




                            <div className="d-flex">
                                <Input
                                    placeholder="Search device"
                                    value={localSearch}
                                    onChange={(e) => setLocalSearch(e.target.value)}
                                    style={{ width: 250, marginRight: 10 }}
                                    allowClear
                                />
                                <Button type="primary" onClick={openAddModal}>
                                    Add Device
                                </Button>






                            </div>
                        </div>
                        <Table
                            columns={columns}
                            dataSource={filteredDevices}
                            rowKey="deviceId"
                            loading={loading}
                            pagination={{ pageSize: 10 }}
                            bordered
                        />
                    </div>
                </div>

                <Modal
                    open={isModalOpen}
                    onCancel={() => setIsModalOpen(false)}
                    onOk={() => form.submit()}
                    title={editingDevice ? "Edit Device" : "Add Device"}
                    okText={editingDevice ? "Update" : "Create"}
                    okButtonProps={{ loading: submitting }}
                    cancelButtonProps={{ disabled: submitting }}
                    width={700}
                    destroyOnClose
                >
                    <Form form={form} layout="vertical" onFinish={handleSubmit}>
                        <Form.Item
                            label="Device Name"
                            name="deviceName"
                            rules={[{ required: true, message: "Device Name is required" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Device Base URL"
                            name="PBX_BASE_URL"
                            rules={[{ required: true, message: "Base URL is required" }]}
                        >
                            <Input placeholder="https://device.example.com" />
                        </Form.Item>

                        <Form.Item
                            label="Device Username"
                            name="PBX_USERNAME"
                            rules={[{ required: true, message: "Username is required" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Device Password"
                            name="PBX_PASSWORD"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="SDK Access ID"
                            name="PBX_SDK_ACCESS_ID"
                            rules={[{ message: "SDK Access ID is required" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="SDK Access Key"
                            name="PBX_SDK_ACCESS_KEY"
                            rules={[{ message: "SDK Access Key is required" }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="PBX Type"
                            name="pbxType"
                            initialValue="cloud"
                        >
                            <Select
                                options={[
                                    { value: "cloud", label: "Cloud" },
                                    { value: "local", label: "Local" },
                                ]}
                            />
                        </Form.Item>
                    </Form>

                </Modal>
            </div>
        </div>
    );
};

export default Devices;